<div class="fd-page" *ngIf="post; else notFound">
  <!-- Voltar -->
  <button class="fd-back" (click)="back()">
    <i class="pi pi-arrow-left"></i> Voltar ao fórum
  </button>

  <div class="fd-card">
    <!-- Coluna de voto -->
    <div class="fd-vote">
      <button class="fd-vote__btn" [class.fd-vote__btn--up]="post.myVote === 1" (click)="votePost(1)">
        <i class="pi pi-chevron-up"></i>
      </button>
      <span class="fd-vote__score" [class.fd-vote__score--up]="post.myVote === 1" [class.fd-vote__score--down]="post.myVote === -1">
        {{ short(post.score) }}
      </span>
      <button class="fd-vote__btn" [class.fd-vote__btn--down]="post.myVote === -1" (click)="votePost(-1)">
        <i class="pi pi-chevron-down"></i>
      </button>
    </div>

    <!-- Conteúdo -->
    <div class="fd-body">
      <div class="fd-meta">
        <button class="fd-community" *ngIf="community" (click)="openCommunity()">
          <span class="fd-community__icon" [style.background]="community.color"><i [class]="community.icon"></i></span>
          {{ community.name }}
        </button>
        <span class="fd-meta__sep">·</span>
        <span class="fd-meta__author">
          {{ post.author.name }}
          <i class="pi pi-verified fd-meta__verified" *ngIf="post.author.isTunner"></i>
        </span>
        <span class="fd-author-flair" *ngIf="post.author.flair">{{ post.author.flair }}</span>
        <span class="fd-meta__sep">·</span>
        <span class="fd-meta__time">{{ post.createdAt }}</span>
      </div>

      <h1 class="fd-title">
        <span class="fd-tag" *ngIf="post.tag" [style.background]="post.tagColor + '22'" [style.color]="post.tagColor">{{ post.tag }}</span>
        {{ post.title }}
      </h1>

      <p class="fd-text">{{ post.body }}</p>

      <div class="fd-media" *ngIf="post.image">
        <div class="fd-media__ph" [attr.data-kind]="post.image">
          <i class="pi pi-image"></i>
          <span>{{ post.image === 'civic' ? 'Foto do projeto' : 'Print do datalogger' }}</span>
        </div>
      </div>

      <div class="fd-actions">
        <span class="fd-action"><i class="pi pi-comment"></i> {{ post.commentsCount }} comentários</span>
        <button class="fd-action fd-action--btn" [class.fd-action--saved]="post.saved" (click)="toggleSave()">
          <i class="pi" [ngClass]="post.saved ? 'pi-bookmark-fill' : 'pi-bookmark'"></i>
          {{ post.saved ? 'Salvo' : 'Salvar' }}
        </button>
        <button class="fd-action fd-action--btn"><i class="pi pi-share-alt"></i> Compartilhar</button>
      </div>
    </div>
  </div>

  <!-- Caixa de novo comentário -->
  <div class="fd-compose">
    <div class="fd-compose__avatar">VC</div>
    <div class="fd-compose__field">
      <textarea
        class="fd-compose__textarea"
        [(ngModel)]="newComment"
        maxlength="2000"
        rows="3"
        placeholder="Adicione um comentário…"
      ></textarea>
      <div class="fd-compose__bar">
        <button class="fd-compose__btn" [disabled]="newComment.trim().length < 2" (click)="submitComment()">
          <i class="pi pi-send"></i> Comentar
        </button>
      </div>
    </div>
  </div>

  <!-- Comentários -->
  <div class="fd-comments">
    <h2 class="fd-comments__title">{{ post.commentsCount }} comentários</h2>

    <div class="fd-comment" *ngFor="let c of post.comments">
      <ng-container *ngTemplateOutlet="commentTpl; context: { $implicit: c, reply: false }"></ng-container>

      <!-- Respostas (1 nível) -->
      <div class="fd-replies" *ngIf="c.replies?.length">
        <div class="fd-comment fd-comment--reply" *ngFor="let r of c.replies">
          <ng-container *ngTemplateOutlet="commentTpl; context: { $implicit: r, reply: true }"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Template de comentário (raiz e resposta) -->
<ng-template #commentTpl let-c let-reply="reply">
  <div class="fd-c">
    <div class="fd-c__avatar" [style.background]="c.author.avatarColor">{{ c.author.initials }}</div>
    <div class="fd-c__main">
      <div class="fd-c__head">
        <span class="fd-c__author">{{ c.author.name }}</span>
        <i class="pi pi-verified fd-c__verified" *ngIf="c.author.isTunner"></i>
        <span class="fd-c__op" *ngIf="c.isOp">OP</span>
        <span class="fd-c__flair" *ngIf="c.author.flair && !c.isOp">{{ c.author.flair }}</span>
        <span class="fd-c__time">· {{ c.createdAt }}</span>
      </div>
      <p class="fd-c__body">{{ c.body }}</p>
      <div class="fd-c__actions">
        <button class="fd-c__vote" [class.fd-c__vote--up]="c.myVote === 1" (click)="voteComment(c, 1)">
          <i class="pi pi-chevron-up"></i>
        </button>
        <span class="fd-c__score" [class.fd-c__score--up]="c.myVote === 1" [class.fd-c__score--down]="c.myVote === -1">{{ short(c.score) }}</span>
        <button class="fd-c__vote" [class.fd-c__vote--down]="c.myVote === -1" (click)="voteComment(c, -1)">
          <i class="pi pi-chevron-down"></i>
        </button>
        <button class="fd-c__reply"><i class="pi pi-reply"></i> Responder</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #notFound>
  <div class="fd-empty">
    <i class="pi pi-inbox"></i>
    <p>Post não encontrado.</p>
    <button class="fd-back" (click)="back()"><i class="pi pi-arrow-left"></i> Voltar ao fórum</button>
  </div>
</ng-template>
